import React, { ChangeEvent, FC } from 'react'
import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import { bankRounding } from 'utils/rounding'
import { DECIMAL_PLACES } from 'constants/calcConstants'

type DecimalTextFieldProps = TextFieldProps & {
  decimalScale?: number
}

function withDecimalLimit<P extends TextFieldProps>(WrappedComponent: React.ComponentType<P>) {
  const ComponentWithDecimalLimit: FC<DecimalTextFieldProps> = ({ onChange, decimalScale = DECIMAL_PLACES, ...props }) => {
    const regex = new RegExp(`^\\d*(\\.\\d{0,${decimalScale}})?$`)
    const cleanInput = (raw: string) => raw.replace(/[^0-9.]/, '')
    const createSyntheticEvent = (e: ChangeEvent<HTMLInputElement>, newValue: string) => {
      return { ...e, target: { ...e.target, name: e.target.name, value: newValue } } as ChangeEvent<HTMLInputElement>
    }

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const cleaned = cleanInput(e.target.value)
      if (cleaned === '' || regex.test(cleaned)) {
        onChange?.(createSyntheticEvent(e, cleaned))
      } else if ((e.nativeEvent as InputEvent).inputType === 'insertFromPaste') {
        const num = parseFloat(cleaned)
        if (Number.isFinite(num)) {
          const rounded = bankRounding(num, decimalScale).toString()
          onChange?.(createSyntheticEvent(e, rounded))
        } else {
          onChange?.(createSyntheticEvent(e, ''))
        }
      }
    }

    return <WrappedComponent {...(props as P)} onChange={handleChange} />
  }

  return ComponentWithDecimalLimit
}

const DecimalTextField = withDecimalLimit(TextField)

export default DecimalTextField
